export interface IConfiguration {
  configuration: IConfigurationParams[];
}

export interface IConfigurationParams {
  configuration: string;
  name: string;
}

export enum ConfigurationNames {
  locatorIcons = 'locator-icons',
  captcha = 'captcha',
  c2c = 'c2c-phases',
  videoCall = 'video-call',
  myopiaControl = 'myopia-control',
  mms = 'mms',
  externalAppointments = 'external-appointments',
  phoneCall = 'phone-call',
  ruStore = 'ru-store',
}
